import { render, staticRenderFns } from "./Prestadores.vue?vue&type=template&id=1232a512&"
import script from "./Prestadores.vue?vue&type=script&lang=js&"
export * from "./Prestadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports